/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationRecapCustomerInfoMutation($input: SaveSimulationRecapCustomerInfo_M_simulation_recapInput!) {
    saveSimulationRecapCustomerInfo_M_simulation_recap(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
